import styled from 'styled-components';

export const ButtonWrapper = styled.div<{
    isVisible: boolean;
}>`
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`;
